import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=1882c53e&scoped=true&"
import script from "./membership.vue?vue&type=script&lang=js&"
export * from "./membership.vue?vue&type=script&lang=js&"
import style0 from "./membership.vue?vue&type=style&index=0&id=1882c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1882c53e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/circleci/repo/components/Loader.vue').default})
